/**
 * Ürün kategori ağacı (flat liste → kök, yaprak, childMap).
 */

const catId = (c) => String(c?.id || c?._id || '');

export function buildUrunCategoryTreeModel(flatCategories) {
  const flat = Array.isArray(flatCategories) ? flatCategories : [];
  const childMap = new Map();
  const nodesById = new Map();

  for (const c of flat) {
    const id = catId(c);
    if (!id) continue;
    nodesById.set(id, c);
    if (!childMap.has(id)) childMap.set(id, []);
    const p = c.ustKategoriId ? String(c.ustKategoriId) : null;
    if (p) {
      if (!childMap.has(p)) childMap.set(p, []);
      childMap.get(p).push(id);
    }
  }

  const allIds = new Set(flat.map((c) => catId(c)).filter(Boolean));
  const leafIds = new Set();
  for (const id of allIds) {
    if ((childMap.get(id) || []).length === 0) leafIds.add(id);
  }

  const roots = flat.filter((c) => !c.ustKategoriId);

  const leavesUnder = (rootId) => {
    const out = new Set();
    const st = [String(rootId)];
    while (st.length) {
      const x = st.pop();
      if ((childMap.get(x) || []).length === 0 && allIds.has(x)) {
        out.add(x);
      }
      for (const ch of childMap.get(x) || []) st.push(ch);
    }
    return out;
  };

  const rootIdsForLeafSet = (leafSet) => {
    const rootsWithAuth = [];
    for (const r of roots) {
      const rid = catId(r);
      const under = leavesUnder(rid);
      if ([...under].some((l) => leafSet.has(l))) rootsWithAuth.push(r);
    }
    return rootsWithAuth;
  };

  return { roots, leafIds, childMap, nodesById, leavesUnder, rootIdsForLeafSet, catId };
}

export function leafIdsFromServiceArea(area) {
  const kats = area?.yetkiliKategoriler || area?.yetkiliKategoriIds || [];
  if (!Array.isArray(kats) || kats.length === 0) return new Set();
  const out = new Set();
  for (const k of kats) {
    if (k && typeof k === 'object') {
      const id = k.id || k._id;
      if (id) out.add(String(id));
    } else if (k) {
      out.add(String(k));
    }
  }
  return out;
}

export function productIdsFromServiceArea(area) {
  const raw = area?.yetkiliUrunIcerikIds || [];
  if (!Array.isArray(raw) || raw.length === 0) return new Set();
  const out = new Set();
  for (const k of raw) {
    if (k && typeof k === 'object') {
      const id = k.id || k._id;
      if (id) out.add(String(id));
    } else if (k) {
      out.add(String(k));
    }
  }
  return out;
}

/** Tam kapsam: kategori ve ürün listeleri boş */
export function isServiceAreaFullProductScope(area) {
  const leaves = leafIdsFromServiceArea(area);
  const products = productIdsFromServiceArea(area);
  return leaves.size === 0 && products.size === 0;
}
